module.exports = __webpack_public_path__ + "img/titlevi.5cd1de5e.png";